import React from "react";
import OnboardingScreen, { OnboardingErrorText, OnboardingTitle } from "../OnboardingScreen";
import { OnboardingGlassButton, OnboardingNextButton } from "../OnboardingButtons";
import PeakTextField from "../PeakTextField";

interface InviteCodeStepProps {
  inviteCode: string;
  canContinue: boolean;
  redeeming?: boolean;
  error?: string | null;
  onChange: (value: string) => void;
  onBack: () => void;
  onApply: () => void;
  onSkip: () => void;
}

const InviteCodeStep: React.FC<InviteCodeStepProps> = ({
  inviteCode,
  canContinue,
  redeeming = false,
  error = null,
  onChange,
  onBack,
  onApply,
  onSkip,
}) => (
  <OnboardingScreen
    onBack={onBack}
    footer={
      <div className="flex flex-col gap-3">
        <OnboardingNextButton
          label={redeeming ? "Applying…" : "Apply code"}
          enabled={canContinue && !redeeming}
          onClick={onApply}
        />
        <OnboardingGlassButton label="No, I don't have a code." enabled={!redeeming} onClick={onSkip} />
      </div>
    }
  >
    <div className="flex flex-col gap-7">
      <OnboardingTitle
        title="Invite Code"
        subtitle="If you were invited by a coach or team, or referred by an athlete enter your code here."
      />
      <div className="flex flex-col gap-2">
        <PeakTextField
          label="Invite code"
          value={inviteCode}
          onChange={onChange}
          placeholder="PEAK-XXXX"
          autoCapitalize="characters"
          autoComplete="off"
          error={Boolean(error)}
          onSubmit={() => canContinue && !redeeming && onApply()}
        />
        <OnboardingErrorText>{error}</OnboardingErrorText>
      </div>
    </div>
  </OnboardingScreen>
);

export default InviteCodeStep;
